import { clsx } from 'clsx';
import { useRef, type ReactNode } from 'react';
import { Tooltip } from '@ics-portal/guardian';
import { type Maybe } from '@models/Maybe';
import {
    mapScoreToSeverityRating,
    mapSeverityRatingToReadableText,
    SeverityRating,
} from '@utils/cvss';
import s from './cvss-severity-indicator.module.scss';

interface CvssSeverityIndicatorProps {
    score?: number | null;
    rating?: Maybe<SeverityRating>;
    square?: boolean;
}

export function CvssSeverityIndicator({
    score,
    rating: ratingProp,
    square,
}: CvssSeverityIndicatorProps): ReactNode {
    const rating =
        ratingProp ?? (score ? mapScoreToSeverityRating(score) : null);

    const classes = clsx(s.indicator, {
        [s.severityCritical]: rating === SeverityRating.Critical,
        [s.severityHigh]: rating === SeverityRating.High,
        [s.severityMedium]: rating === SeverityRating.Medium,
        [s.severityLow]: rating === SeverityRating.Low,
        [s.SeverityNone]: rating === SeverityRating.None,
        [s.blank]: !rating,
        [s.square]: square,
    });
    const severityWrapper = useRef(null);

    if (!rating) {
        return <span className={classes} title="" />;
    }

    return (
        <>
            <Tooltip target={severityWrapper} position="left">
                {mapSeverityRatingToReadableText(rating)}
            </Tooltip>
            <span ref={severityWrapper} className={classes} title="" />
        </>
    );
}
